import { setOtpVerifiedEmailAction } from 'common/commonRedux/auth/actions';
import { useIsDark } from 'common/hooks';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import topImg from '../authTop.png';
import logo from '../otpVerificaton/logo.png';
import background from '../signUp/signup_bg.png';
import SendOTPToVerifyEmail from './SendOTPToVerifyEmail';
import VerifyEmail from './VerifyEmail';
import reviewIcon from '../../auth/start.png';
export function ForgetPassword() {
  const isDark = useIsDark();
  const { auth } = useSelector((state: any) => state, shallowEqual);
  const dispatch: any = useDispatch();
  const email = useSelector(
    (state: any) => state.auth?.profileData?.otpVerifiedEmail
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuth) {
      navigate('/');
    }
  }, [auth]);

  useEffect(() => {
    dispatch(setOtpVerifiedEmailAction(''));
  }, [dispatch]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 w-full h-screen overflow-hidden">
      <div className={`w-full h-full flex flex-col justify-center items-center px-4 relative md:px-12 ${isDark ? 'bg-[#0B172B]' : 'bg-[#DEEDFF]'}`}>
        <img src={topImg} alt="" className="absolute top-0 left-0" />
        <div className="flex flex-col justify-center items-center gap-4 mb-6">
          <img src={logo} alt="Trackforce Logo" className="w-[120px] object-contain" />
          <h1 className={`text-2xl font-semibold ${isDark ? 'text-white' : 'text-[#334155]'}`}>Reset Password</h1>
        </div>
        <div className="w-full md:max-w-lg">
          {email ? <VerifyEmail /> : <SendOTPToVerifyEmail />}
        </div>
      </div>

      <div className="h-full relative bg-[#0f172a] hidden lg:flex flex-col justify-center items-center">
        <div className="absolute inset-0 z-0 opacity-50">
          <img src={background} alt="" className="w-full h-full object-cover" />
        </div>
        <div className="relative z-10 space-y-4 text-white text-center px-12">
          <h1 className="lg:text-[40px] font-semibold w-full md:max-w-3xl leading-normal">
            The simplest way to manage your Team
          </h1>
          <p className="font-normal text-base text-gray-300">
            Enter required information to reset your password
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl w-full text-white absolute bottom-12 px-4">
          <div className="bg-[#FFFFFF66] rounded-xl px-4 py-5 flex flex-col gap-1 items-start" style={{ boxShadow: "1.546px 2.319px 0 0 rgba(255, 255, 255, 0.60) inset, -14.336px 43.197px 52.865px 0 rgba(81, 78, 120, 0.18)" }}>
            <h1 className="text-[35px] font-bold ">90%</h1>
            <p className=" text-[16px] font-normal">Better Remote Work Efficiency</p>
          </div>
          <div className="bg-[#FFFFFF66] rounded-xl px-4 py-5 flex flex-col gap-1 items-start" style={{ boxShadow: "1.546px 2.319px 0 0 rgba(255, 255, 255, 0.60) inset, -14.336px 43.197px 52.865px 0 rgba(81, 78, 120, 0.18)" }}>
            <div className="flex flex-wrap items-center gap-1">
              <h1 className="text-[18px] font-bold ">Excellent </h1>
              <div className="mx-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="1" height="15" viewBox="0 0 1 15" fill="none">
                  <path d="M0.5 0V15" stroke="#AEAEAE" />
                </svg>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                  <path d="M8.33628 11.9876L11.9586 11.0731L13.472 15.7198L8.33628 11.9876ZM16.6726 5.98145H10.2963L8.33628 0L6.37626 5.98145H0L5.16056 9.68896L3.20053 15.6704L8.36109 11.9629L11.5368 9.68896L16.6726 5.98145Z" fill="#219653" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold">Trustpilot</h3>
            </div>
            <p className=" text-[16px] font-normal">Based on 456 reviews</p>
            <img src={reviewIcon} alt="Review Icon" className="mt-1" />
          </div>
          <div className="bg-[#FFFFFF66] rounded-xl px-4 py-5 flex flex-col gap-1 items-start" style={{ boxShadow: "1.546px 2.319px 0 0 rgba(255, 255, 255, 0.60) inset, -14.336px 43.197px 52.865px 0 rgba(81, 78, 120, 0.18)" }}>
            <h1 className="text-[35px] font-bold ">80%</h1>
            <p className=" text-[16px] font-normal max-w-xs">Increased <br></br>
              Productivity</p>
          </div>
        </div>
      </div>
    </div>
  );
}
